import React from 'react';
import { AlertCircle, TrendingDown, Clock, Zap, Target } from 'lucide-react';

const CommonMistakesNew = () => {
  const mistakes = [
    { icon: <AlertCircle className="w-10 h-10" />, text: 'Blocking authority' },
    { icon: <TrendingDown className="w-10 h-10" />, text: 'Leaking money' },
    { icon: <Clock className="w-10 h-10" />, text: 'Creating overwork' },
    { icon: <Zap className="w-10 h-10" />, text: 'Attracting chaos instead of stability' },
    { icon: <Target className="w-10 h-10" />, text: 'Sending the wrong signal to opportunity' }
  ];

  const clientExamples = [
    { name: 'Shaifudin', role: 'Entrepreneur', location: 'SG', image: 'https://customer-assets.emergentagent.com/job_feng-shui-signup/artifacts/oa7z3hu7_tmpopn8mh6t.webp' },
    { name: 'Colin', role: 'Property Agent', location: 'SG', image: 'https://customer-assets.emergentagent.com/job_feng-shui-signup/artifacts/5r7jali1_tmpn4zkqqt0.webp' },
    { name: 'Maggie Teo', role: 'Accountant', location: 'SG', image: 'https://customer-assets.emergentagent.com/job_feng-shui-signup/artifacts/bba5v4nx_tmpbxq56a46.webp' },
    { name: 'Kamila', role: 'Entrepreneur', location: 'MY', image: 'https://customer-assets.emergentagent.com/job_feng-shui-signup/artifacts/cth8j020_tmpzv_cmjnf.webp' },
    { name: 'Mindy', role: 'Senior Admin', location: 'SG', image: 'https://customer-assets.emergentagent.com/job_feng-shui-signup/artifacts/cvjtcdnz_tmpucwiq4tc.webp' },
    { name: 'Olivier Ting', role: 'Engineer & Consultant', location: 'MY', image: 'https://customer-assets.emergentagent.com/job_feng-shui-signup/artifacts/hi7b7d96_tmpv0gjc0_n.webp' }
  ];

  return (
    <div className="py-24 bg-[#111113]">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <p className="text-[#F5A623] text-sm font-semibold tracking-wider uppercase mb-4">
            Why This Is For You
          </p>
          <h2 className="text-5xl font-bold text-white mb-6">
            Common <span className="italic text-[#F5A623]">Mistakes</span> That Create Blockages
          </h2>
          <p className="text-xl text-gray-400">Your current signature might be:</p>
        </div>

        {/* Mistakes Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-6 mb-16 max-w-6xl mx-auto">
          {mistakes.map((mistake, index) => (
            <div 
              key={index}
              className="bg-[#1A1A1D] border border-white/10 p-6 rounded-xl text-center hover:border-[#F5A623]/50 transition-all duration-300 hover:scale-105"
            >
              <div className="text-[#F5A623] mb-4 flex justify-center">{mistake.icon}</div>
              <p className="text-white font-semibold">{mistake.text}</p>
            </div>
          ))}
        </div>

        <div className="text-center mb-16">
          <p className="text-2xl text-white font-bold mb-2">
            Most people work harder to compensate.
          </p>
          <p className="text-2xl text-[#F5A623] font-bold">
            We remove the conflict instead.
          </p>
        </div>

        {/* Client Examples */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {clientExamples.map((client, index) => (
            <div 
              key={index}
              className="bg-[#1A1A1D] border border-white/10 rounded-xl overflow-hidden hover:border-[#F5A623]/50 transition-all duration-300"
            >
              <img 
                src={client.image}
                alt={client.name}
                className="w-full h-auto object-contain bg-white"
              />
              <div className="p-4">
                <p className="text-white font-bold text-lg">{client.name}</p>
                <p className="text-[#F5A623] text-sm">{client.role}</p>
                <p className="text-gray-400 text-xs">from {client.location}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Disclaimer */}
        <div className="text-center mt-12">
          <p className="text-gray-400 text-sm italic max-w-3xl mx-auto">
            The examples are illustration purposes only. Any improvements of the signature require professional advise and activation process.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CommonMistakesNew;